import { AppDispatch } from "../../store";
import { RootState } from "../../store/types";
import { connect } from "react-redux";
import ReviewAndPublish from "./index";
import { GetShiftPlanOutputRequest } from "./model";
import { getShiftPlanOutputThunk, publishShiftPlanThunk } from "../../store/slices/reviewAndPublishSlice";

const mapStateToProps = (state: RootState) => ({
    shiftPlanOutput: state.reviewAndPublish.shiftPlanOutput,
    planId: state.shiftPlan.planId,
    date: state.shiftPlan.selectedDate,
    shiftType: state.shiftPlan.selectedShift,
    planType: state.shiftPlan.selectedPlan,
    stationCode: state.shiftPlan.stationCode
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
    getShiftPlanOutput: (getShiftPlanOutputRequest: GetShiftPlanOutputRequest) => dispatch(getShiftPlanOutputThunk(getShiftPlanOutputRequest)),
    publishShiftPlan: async (planId: string, shiftType: string) => await dispatch(publishShiftPlanThunk({ planId, shiftType }))
});

export default connect(mapStateToProps, mapDispatchToProps)(ReviewAndPublish);